// ModalDepartment.js
import React from 'react';

const ModalDepartment = ({
  editDepartment,
  handleInputChange,
  handleSave,
  closeModal,
  handleImageChange,
}) => {
  return (
    <div className="fixed inset-0 flex justify-center items-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg w-3/4 md:w-1/2">
        <h3 className="text-2xl font-semibold mb-4">Edit Department</h3>

        {/* Using grid layout to display 3 fields per row */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
          {/* Department Name */}
          <div className="mb-4">
            <label className="block text-gray-600">Department Name</label>
            <input
              type="text"
              name="name"
              value={editDepartment.name}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Head */}
          <div className="mb-4">
            <label className="block text-gray-600">Head</label>
            <input
              type="text"
              name="head"
              value={editDepartment.head}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Building */}
          <div className="mb-4">
            <label className="block text-gray-600">Building</label>
            <input
              type="text"
              name="building"
              value={editDepartment.building}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Office Number */}
          <div className="mb-4">
            <label className="block text-gray-600">Office Number</label>
            <input
              type="text"
              name="office"
              value={editDepartment.office}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Email */}
          <div className="mb-4">
            <label className="block text-gray-600">Email</label>
            <input
              type="email"
              name="email"
              value={editDepartment.email}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Budget */}
          <div className="mb-4">
            <label className="block text-gray-600">Budget</label>
            <input
              type="text"
              name="budget"
              value={editDepartment.budget}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          {/* Description */}
          <div className="mb-4 col-span-2">
            <label className="block text-gray-600">Description</label>
            <textarea
              name="description"
              value={editDepartment.description}
              onChange={handleInputChange}
              className="w-full p-2 border border-gray-300 rounded-md"
              rows="2"
            />
          </div>

          <div className="mb-4 col-span-2">
            <label className="block text-gray-600">Image</label>
            {editDepartment.image && (
              <div className="mb-2">
                <img
                  src={editDepartment.image}
                  alt="Department"
                  className="w-32 h-32 object-cover rounded-md"
                />
              </div>
            )}
            <input
              type="file"
              name="image"
              onChange={handleImageChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end mt-4">
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white p-2 rounded-md"
          >
            Save Changes
          </button>
          <button
            onClick={closeModal}
            className="bg-gray-300 text-black p-2 rounded-md ml-2"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalDepartment;
